import { useSelector } from "react-redux";
import ChatBody from "../../../../components/ui/chat/ChatBody";
import LoadingPlaceholder from "../../../../components/ui/loading/LoadingPlaceholder";
import { useEffect } from "react";

function FilingMessagesV2() {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);

  // GATE 1: Wait for the Redux 'Check Auth' action to finish
  if (isLoading) {
    return (
      <div className="content">
        <LoadingPlaceholder rows={3} type="card-large" />
      </div>
    );
  }

  // GATE 2: If Redux says not authenticated, don't render ChatBody.
  // Your ProtectedRoute or Router should handle the actual redirect to login.
  if (!isAuthenticated) {
    return null;
  }

  // Render chat body if everything is good
  return <ChatBody />;
}

export default FilingMessagesV2;
